var BundeInputs = document.querySelectorAll('.bundle_input_block');
var VariantOptionsList = document.querySelectorAll('.loop_per_options_block');
let VarantsArray = [];
//    // New Code
//       const bundleInputs = document.querySelectorAll('.bundle_input_block');
//       const allFreeOnes = document.querySelector(".free_products_wrap_bundles");
//       const freeMsg = document.querySelector("#unlockText");
// bundleInputs?.forEach(input => {
//      const firstBundleInput = document.querySelector('.free_product_input_bundles');
//      if(firstBundleInput){ firstBundleInput.checked = true;}
//   input?.addEventListener('change', function() {
//     const checkedBundle = document.querySelector('.bundle_input_block:checked');
//     const checkedBundleValue = checkedBundle.value;
//     console.log("CheckedBundleValue", checkedBundleValue);
//     if (Number(checkedBundleValue) === 1) {
//       allFreeOnes?.classList.add("unactive");
//       freeMsg?.classList.remove("hidden");
//      if(firstBundleInput){ firstBundleInput.checked = false;}
//     } else {
//       allFreeOnes?.classList.remove("unactive");
//       freeMsg?.classList.add("hidden");
//       if(firstBundleInput){firstBundleInput.checked = true;}
//     }
//   });
// });
//    // New code ends

function updatePrices(element) {
    let PriceNormal = 0;
    let PriceCompare = 0;
    var MainLabel = element.closest('.bundle_block_wrapper');
    var ThisPriceNormal = MainLabel.querySelector('.bundle_normal_price');
    var ThisPriceCompare = MainLabel.querySelector('.bundle_compare_price');
    var ThisPriceSymble = MainLabel.getAttribute('data-price-symble');
    var ThisVariantsList = MainLabel.querySelectorAll('.loop_per_options_block');
   let FinalDiscountPrice = 0;
   
   // Store current price as fallback - DON'T overwrite if calculation fails
   var currentPrice = ThisPriceNormal ? ThisPriceNormal.textContent.trim() : null;
   var hasValidPrice = false;
   
  console.log('Is working')
    ThisVariantsList.forEach((List) => {
        var SelectedOptions = List.querySelectorAll('option:checked');
        let VariantValues = [];
        SelectedOptions.forEach((Option) => {
            VariantValues.push(Option.getAttribute('value'));
        });
        let VariantValue = VariantValues.join('-');
        var MainLoopParent = MainLabel.querySelector('.block_products_options_bundle');
        if (!MainLoopParent) return;
        var VariantsSelectBox = MainLoopParent.querySelector('.variant_bundle_selection');
        if (!VariantsSelectBox) return;
        var VariantOption = VariantsSelectBox.querySelector('option[value="' + VariantValue + '"]');
        if (VariantOption) {
          List.setAttribute('selected-variant-id', VariantOption.getAttribute('data-variant-id'))
            var variantPriceNormal = parseFloat(VariantOption.getAttribute('data-variant-price-normal'));
            var variantPriceCompare = parseFloat(VariantOption.getAttribute('data-variant-price-compare'));
            if (!isNaN(variantPriceNormal) && variantPriceNormal > 0) {
                PriceNormal += variantPriceNormal;
                hasValidPrice = true;
            }
            if (!isNaN(variantPriceCompare) && variantPriceCompare > 0) {
                PriceCompare += variantPriceCompare;
            }
            var discountPercent = parseFloat(VariantOption.getAttribute('discount-percentage')) || 0;
            // Calculate discount amount (precise, matching Liquid calculation)
            var pricePercentage = (variantPriceNormal * discountPercent) / 100;
            // Calculate discounted price per item (matching Liquid: price - price_percentage)
            var variantDiscountedPrice = variantPriceNormal - pricePercentage;
            FinalDiscountPrice += variantDiscountedPrice;
            console.log("Total Price", Math.floor((PriceNormal * discountPercent) / 100));
        }
    });
    // var NewDiscountedPrice = Math.floor(PriceNormal * discountPercent);
    
    // ThisPriceNormal.textContent = ThisPriceSymble + Math.round(PriceNormal);
    // ThisPriceCompare.textContent = ThisPriceSymble + Math.round(PriceCompare);
    // Note: FinalDiscountPrice is already in DOLLARS (not cents) because data-variant-price-normal is divided by 100 in Liquid
    var totalPriceInDollars = FinalDiscountPrice;
    
    // Check bundle title and divide price by total bottles for special bundles
    var bundleTitle = MainLabel.getAttribute('data-bundle-title');
    var finalPriceInDollars = totalPriceInDollars;
    
    if (bundleTitle) {
        var bundleTitleLower = bundleTitle.toLowerCase();
        // Check for "Buy 2 Get 1 Free" variations (with or without comma, "Bottle", "Scent", etc.)
        if (bundleTitleLower.indexOf('buy 2') !== -1 && bundleTitleLower.indexOf('get 1 free') !== -1) {
            // Divide by 3 (2 paid + 1 free = 3 total bottles) - price is already in dollars
            finalPriceInDollars = totalPriceInDollars / 3;
        } 
        // Check for "Buy 3 Get 2 Free" variations (with or without comma, "Bottles", etc.)
        else if (bundleTitleLower.indexOf('buy 3') !== -1 && bundleTitleLower.indexOf('get 2 free') !== -1) {
            // Divide by 5 (3 paid + 2 free = 5 total bottles) - price is already in dollars
            finalPriceInDollars = totalPriceInDollars / 5;
        }
    }
    // Prices are already in dollars, so use directly (no need to divide by 100)
    var finalPrice = finalPriceInDollars;
    var roundedPrice = totalPriceInDollars; // For button, use total price in dollars
    
    // Check if price should be preserved (from Liquid calculation)
    var shouldPreservePrice = ThisPriceNormal && ThisPriceNormal.getAttribute('data-preserve-per-bottle') === 'true';
    
    // If price should be preserved, use the data-price-cents attribute to restore the original Liquid-calculated price
    if (shouldPreservePrice && ThisPriceNormal) {
        var priceCents = parseFloat(ThisPriceNormal.getAttribute('data-price-cents'));
        if (!isNaN(priceCents) && priceCents > 0) {
            // Convert cents to dollars and format with 2 decimal places
            var preservedPrice = (priceCents / 100).toFixed(2);
            ThisPriceNormal.textContent = ThisPriceSymble + preservedPrice;
        } else if (currentPrice && currentPrice !== '₱0.00' && currentPrice !== '$0.00' && currentPrice !== '0.00') {
            // Fallback to current price if data-price-cents is not available
            ThisPriceNormal.textContent = currentPrice;
        }
    } else if (!shouldPreservePrice && hasValidPrice && finalPrice > 0 && roundedPrice > 0 && ThisPriceNormal) {
        // Only update if price is NOT marked to preserve
        ThisPriceNormal.textContent = ThisPriceSymble + finalPrice.toFixed(2);
    } else if (ThisPriceNormal && currentPrice && currentPrice !== '₱0.00' && currentPrice !== '$0.00' && currentPrice !== '0.00') {
        // Keep the existing price if calculation failed
        ThisPriceNormal.textContent = currentPrice;
    }
    
    if (hasValidPrice && PriceCompare > 0 && ThisPriceCompare) {
        // PriceCompare is already in dollars (from data-variant-price-compare)
        ThisPriceCompare.textContent = ThisPriceSymble + PriceCompare.toFixed(2);
    }
    
    // Check for new-set element and update it (round first, then divide by 3, then round up)
    var NewSetElement = MainLabel.querySelector('.new-set');
    if (NewSetElement) {
        var newSetPrice = roundedPrice / 3;
        // Round up after dividing by 3 (e.g., 21.33 becomes 22)
        newSetPrice = Math.ceil(newSetPrice);
        NewSetElement.textContent = ThisPriceSymble + newSetPrice.toFixed(2);
    }
    console.log('PriceNormal', PriceNormal);
    
    // Update button prices - calculate from preserved per-bottle price to avoid rounding issues
    const buttonPriceElements = document.querySelectorAll('.add-to-cart_bundle .product__price');
    const buttonComparePriceElements = document.querySelectorAll('.add-to-cart_bundle .product__price--compare');
    
    if (buttonPriceElements.length > 0) {
        var buttonPrice = '';
        
        // If price should be preserved, calculate button price from preserved per-bottle price
        if (shouldPreservePrice && ThisPriceNormal) {
            var priceCents = parseFloat(ThisPriceNormal.getAttribute('data-price-cents'));
            if (!isNaN(priceCents) && priceCents > 0) {
                // Get bundle quantity and free items to determine total bottles
                var bundleInput = MainLabel.querySelector('.bundle_input_block');
                var packQuantity = bundleInput ? parseInt(bundleInput.value) || 1 : 1;
                var freeItems = bundleInput ? parseInt(bundleInput.getAttribute('data-free-items')) || 0 : 0;
                var totalBottles = packQuantity + freeItems;
                
                // The data-price-cents is the per-bottle price (already divided by total bottles in Liquid)
                // To get the total price you're paying: per-bottle price × total bottles
                // This gives us the original total_price before division
                var perBottlePriceInCents = priceCents;
                var totalPriceInCents = perBottlePriceInCents * totalBottles;
                var totalPriceInDollars = totalPriceInCents / 100;
                buttonPrice = ThisPriceSymble + totalPriceInDollars.toFixed(2);
            } else {
                // Fallback to calculated price if preserved price not available
                buttonPrice = ThisPriceSymble + roundedPrice.toFixed(2);
            }
        } else {
            // Use calculated price if not preserving
            buttonPrice = ThisPriceSymble + roundedPrice.toFixed(2);
        }
        
        buttonPriceElements.forEach(el => {
            el.textContent = buttonPrice;
        });
    }
    
    if (buttonComparePriceElements.length > 0 && ThisPriceCompare) {
        const comparePrice = ThisPriceCompare.textContent.trim();
        buttonComparePriceElements.forEach(el => {
            el.textContent = comparePrice;
        });
    }
}
if(BundeInputs && BundeInputs.length > 0){
  BundeInputs.forEach((input) => {
    input.addEventListener('change', function() {
        var ThisParent = this.closest('.bundle_block_wrapper');
        var MainLabel = this.closest('.bundle_block_wrapper');
        var LimitInput = document.querySelector('.free_products_limit_bundle');
       
         checkGiftItems()
        var NewLimit = this.value 
        updatePrices(this);
       checkAllFreeItemsQty(this);
      if(LimitInput){
        LimitInput.value = NewLimit
        console.log('ckeck',NewLimit )
      checkAllValues(this)
      }
    });
    // Only update prices for the checked/selected bundle on initial load
    if (input.checked) {
      updatePrices(input);
    }
});
}
if(VariantOptionsList && VariantOptionsList.length > 0 ){
VariantOptionsList.forEach((List) => {
    var VariantOptions = List.querySelectorAll('select.option_select_box');
    VariantOptions.forEach((OptionVariant) => {
        OptionVariant.addEventListener('change', function() {
            updatePrices(this);
            var ThisParent = this.closest('.loop_per_options_block');
            var SelectedOptions = ThisParent.querySelectorAll('option:checked');
            let VariantValues = [];
            SelectedOptions.forEach((Option) => {
                VariantValues.push(Option.getAttribute('value'));
            });
            let VariantValue = VariantValues.join('-');
            var MainLoopParent = ThisParent.closest('.block_products_options_bundle');
            var VariantsSelectBox = MainLoopParent.querySelector('.variant_bundle_selection');
            var VariantOption = VariantsSelectBox.querySelector('option[value="' + VariantValue + '"]');
            var ErrorMessage = ThisParent.querySelector('.error-message-options');
             
            if (VariantOption) {
                if (ErrorMessage) {
                    ErrorMessage.remove();
                }
            } else {
                if (!ErrorMessage) {
                    var NewMessage = document.createElement('span');
                    NewMessage.classList.add('error-message-options');
                    NewMessage.textContent = 'Sorry, this is not currently available.';
                    ThisParent.append(NewMessage);
                }
            }
        });
    });

    var SelectedOptions = List.querySelectorAll('option:checked');
    let VariantValues = [];
    SelectedOptions.forEach((Option) => {
        VariantValues.push(Option.getAttribute('value'));
    });
    let VariantValue = VariantValues.join('-');
    var MainLoopParent = List.closest('.block_products_options_bundle');
    var VariantsSelectBox = MainLoopParent.querySelector('.variant_bundle_selection');
    var VariantOption = VariantsSelectBox.querySelector('option[value="' + VariantValue + '"]');
    var ErrorMessage = List.querySelector('.error-message-options');

    if (VariantOption) {
       
        if (ErrorMessage) {
            ErrorMessage.remove();
        }
        List.setAttribute('selected-variant-id', VariantOption.getAttribute('data-variant-id'));
    } else {
        if (!ErrorMessage) {
            var NewMessage = document.createElement('span');
            NewMessage.classList.add('error-message-options');
            NewMessage.textContent = 'Sorry, this is not currently available.';
            List.append(NewMessage);
        }
    }
});
}

// ======================== Add To Cart Function ===================
function trackAddToCart(variantIds) {
  if (typeof ttq !== 'undefined') {
    ttq.track('AddToCart', {
      content_id: variantIds.join(','), // Assuming variantIds is an array of IDs
      content_type: 'product'
    });
  }
}

// Select all buttons with the attribute 'add-to-cart-bundle'
const AllAddtoCartBtns = document.querySelectorAll('[add-to-cart-bundle]');

if (AllAddtoCartBtns && AllAddtoCartBtns.length > 0) {
  AllAddtoCartBtns.forEach(button => {
    button.addEventListener('click', function() {
      let mainWrapper = this.closest('.product-single__meta');
      if(!mainWrapper){
        mainWrapper = document.querySelector('body')
      }
      const variantIds = [];
      var propertyname = this.getAttribute('data-properties-name');
      var propertyvalue = this.getAttribute('data-properties-value');
      // Check if button should redirect to checkout
      const redirectToCheckout = this.getAttribute('data-redirect-to-checkout') === 'true';
       var DefaultVariant = mainWrapper ? mainWrapper.querySelector('.variant_id_input:checked') : null;
       var DefaultVariantQty = mainWrapper ? mainWrapper.querySelector('.variant_quantity') : null;
      if(DefaultVariant){
       variantIds.push({ id: DefaultVariant.value, quantity: DefaultVariantQty.value });
      }
      // Get checked variants for the main product bundle
   
      const selectedVariants = mainWrapper.querySelectorAll('.bundle_input_block:checked + label .loop_per_options_block');
      selectedVariants.forEach(variant => {
        const variantId = variant.getAttribute('selected-variant-id');
        if (variantId) {
          variantIds.push({ id: variantId, quantity: 1 }); // Default quantity of 1 for each variant
        }
      });

      
      // Get checked free products
     var Pages  =  document.querySelector('.product--venom-03') ?  document.querySelector('.product--venom-03'): document.querySelector('.product--venom-pheromone-perfume-collection');
     const selectedBundleInput = Pages? Pages.querySelector('.bundle_input_block:checked') : document.querySelector('.bundle_input_block:checked') ;
let freeQuantity = 1; // Default quantity if no specific value is set

if (selectedBundleInput) {

  freeQuantity = selectedBundleInput.getAttribute('data-free-items') || 1;
  console.log("Selected Bundle Free Items:", freeQuantity);
}

// Get all checked free product inputs
const freeProducts = mainWrapper.querySelectorAll('.free_products_wrap_bundles input:checked');

freeProducts.forEach(freeProduct => {
  if (freeProduct) {
    const quantity = freeQuantity;
    
    // Check for attributes and retrieve their values
    const isFreeGift = freeProduct.getAttribute('katching-free-gift') === "true";
    const dealId = freeProduct.getAttribute('katching-deal-id');
    const katchingFreeId = document.querySelector('.bundle_input_block:checked')?.getAttribute('katching-free-gift-id');

    // Prepare properties object
    const properties = {};
    if (isFreeGift) {
      properties.__kaching_free_gift = true;
    }
    if (dealId && katchingFreeId) {
      properties.__kaching_free_gift = JSON.stringify({
    id: katchingFreeId,
    dealBlockId: dealId
  });
    }

    // Add the free product's variant ID, quantity, and properties to the variantIds array
    variantIds.push({
      id: freeProduct.value,
      quantity: quantity,
      properties: properties
    });
  }
});

      const GiftItesm  =  document.querySelectorAll('[gift-item][is-current-item]')
     GiftItesm?.forEach((item) => {
       let giftQty = item ? 1 : 1 ;
       variantIds.push({ id: parseInt(item.getAttribute('data-id')), quantity: giftQty });
     })
      // Get products with specific quantities from the landing page
      const landingProductsFree = mainWrapper.querySelectorAll('.qty_input');
      landingProductsFree.forEach(freeProduct => {
        const quantity = parseInt(freeProduct.value, 10);
        if (freeProduct && quantity > 0) {
          variantIds.push({ id: freeProduct.getAttribute('data-id'), quantity });
        }
      });

      // Add items to the cart if any variants were found
      if (variantIds.length) {
        if(propertyname && propertyvalue){
        addToCart(variantIds, propertyname , propertyvalue, redirectToCheckout);
        }else{
        addToCart(variantIds, null, null, redirectToCheckout);
        }
      } else {
        console.warn('No variant IDs found to add to cart');
      }
    });
  });
}

async function addToCart(variantIds, propertyname, propertyvalue, redirectToCheckout = false) {
  try {
    const randomNumber = Math.floor(10000000 + Math.random() * 90000000);
   
    // Prepare items with custom quantities and random number property
    const items = variantIds.map(({ id, quantity, properties = {} }) => {
      const item = {
        id,
        quantity,
        properties: {
          ...properties, // Merge existing properties
          _random_number: randomNumber
        }
      };
        
      // Check if propertyname and propertyvalue are provided
      if (propertyname && propertyvalue) {
        item.properties[propertyname] = propertyvalue; // Add new property to the properties object
      }
      
      return item;
    });

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items })
    });

    if (!response.ok) throw new Error(`Error adding items to cart: ${response.statusText}`);

    const result = await response.json();
    console.log('Items added to cart:', result);

    // Only pass variant IDs to trackAddToCart
    trackAddToCart(variantIds.map(item => item.id));
    
    // Redirect to checkout if specified, otherwise update cart drawer
    if (redirectToCheckout) {
      window.location.href = '/checkout';
    } else {
      await updateCartDrawer();
    }

  } catch (error) {
    console.error('Error adding items to cart:', error);
  }
}


async function updateCartDrawer() {
  setTimeout(async function() {
    if (typeof theme !== 'undefined' && typeof theme.CartDrawer !== 'undefined') {
      var cart = new theme.CartDrawer();
      
      if (typeof cart.init === 'function' && typeof cart.open === 'function') {
        cart.init();
        cart.open();
      }

      try {
        const cartData = await fetch('/cart.js').then(response => response.json());
        document.querySelectorAll('.drcart_count').forEach(el => el.textContent = cartData.item_count);

      } catch (error) {
        console.error('Failed to fetch cart data:', error);
      }
    }
  }, 500);
}

// ================================Landing Bundles ==========================
  var AddBtnsFree = document.querySelectorAll('.icon_add_qty_landing') ? document.querySelectorAll('.icon_add_qty_landing') : document.querySelectorAll('.icon_add_qty_bundle') ;
if(AddBtnsFree.length === 0){
   var AddBtnsFree = document.querySelectorAll('.icon_add_qty_bundle')
}
if(AddBtnsFree){
AddBtnsFree.forEach((btn) =>{
btn.addEventListener('click', function(){
var ThisParent = this.closest('.landing_bundle-free-p') ? this.closest('.landing_bundle-free-p'): this.closest('.option-single_bundles') ;
var ThisQty = ThisParent ? ThisParent.querySelector('.qty_input') : null;
var ThisQtyWrapper = ThisParent ? ThisParent.querySelector('.landing_bundle_qty_btns') ? ThisParent.querySelector('.landing_bundle_qty_btns') : ThisParent.querySelector('.free-item-qty-wrapper') : null;
 console.log('ThisQtyWrapper', ThisQtyWrapper)
  ThisQtyWrapper.classList.remove('hidden')
ThisQty.value = 1;
ThisQty.setAttribute('value', 1);
this.classList.add('hidden');
  if(ThisParent.querySelector('.landing_bundle_qty_btns')){
  checkAllValues(this)
  }
   if(ThisParent.querySelector('.free-item-qty-wrapper')){
  checkAllFreeItemsQty(this)
   }
});
})
}
  var LimitBtns = document.querySelectorAll('.bundle_input_radio');
if(LimitBtns){
LimitBtns.forEach((btn) =>{
btn.addEventListener('change', function(){
   var ThisLimit = document.querySelector('.free_products_limit_bundle');
 ThisLimit.value = this.value
  checkAllValues(this)
  
      checkGiftItems();
});
})
}
var tabs = document.querySelectorAll('.tab_open_btn_free');
if(tabs){
tabs.forEach((btn) => {
  btn.addEventListener('click', function() {
    var allTabs = document.querySelectorAll('.tabs_content_wrapper');
    allTabs.forEach((t) => { t.style.display = 'none'; });
    tabs.forEach((t) => { t.classList.remove('active_tab'); });
     this.classList.add('active_tab')
    var selectedTabs = document.querySelectorAll(`.${this.getAttribute('data-title')}`);
    selectedTabs.forEach((t) => { t.style.display = 'flex'; });
     if(document.querySelector('.landing_bundle_qty_btns')){
  checkAllValues(this)
  }
   if(document.querySelector('.free-item-qty-wrapper')){
  checkAllFreeItemsQty(this)
   }
  });
 
});
}
 checkAllValues(tabs[0])

  document.addEventListener('DOMContentLoaded', function() {
  const incrementButtons = document.querySelectorAll('.icon_qty_plus');
  const decrementButtons = document.querySelectorAll('.icon_qty_minus');

  incrementButtons.forEach(button => {
    button.addEventListener('click', function() {
      let wrapper =  this.closest('.landing_bundle_qty_btns') ?  this.closest('.landing_bundle_qty_btns') :  this.closest('.free-item-qty-wrapper');
      const input = wrapper.querySelector('.qty_input');
      let currentValue = parseInt(input.value) || 0;
      input.value = currentValue + 1;
      if(document.querySelector('.landing_bundle_qty_btns')){
  checkAllValues(this)
  }
   if(document.querySelector('.free-item-qty-wrapper')){
  checkAllFreeItemsQty(this)
   }
    });
  });
  decrementButtons.forEach(button => {
    button.addEventListener('click', function() {
   let wrapper =  this.closest('.landing_bundle_qty_btns') ?  this.closest('.landing_bundle_qty_btns') :  this.closest('.free-item-qty-wrapper');
      const input = wrapper.querySelector('.qty_input');
      let currentValue = parseInt(input.value) || 0;
      if (currentValue >= 0) {
        input.value = currentValue - 1; 
      }
         if(document.querySelector('.landing_bundle_qty_btns')){
  checkAllValues(this)
  }
   if(document.querySelector('.free-item-qty-wrapper')){
  checkAllFreeItemsQty(this)
   }
    });
  });
});
checkAllFreeItemsQty(document.querySelector('.bundle_input_block:checked'))
// ================================Free Items =============================
 function checkAllFreeItemsQty(This){
  let checkedBundel = document.querySelector('.bundle_input_block:checked')
   let ThisParent = This ? This.closest('.product-single__meta') : null;
  if(!ThisParent){ThisParent = document.querySelector('body');}
  var AllfreeProducts = ThisParent ? ThisParent.querySelectorAll('.qty_input') : null;
  var ThisLimit = checkedBundel ? checkedBundel.getAttribute('data-free-items') : 0;
  var Values = 0;
  if(parseInt(ThisLimit) === 0){
    document.querySelectorAll('.option-single_bundles')?.forEach((btn) => {btn.classList.add('disabled_free_items')});
    document.querySelector('#unlockText')?.classList.remove("hidden");
    document.querySelector('#unlockText2')?.classList.add("hidden");
    document.querySelector('#unlockText3')?.classList.add("hidden");
     const freeInput = document.querySelector('.free_product_input_bundles');
         if (freeInput) {
        freeInput.checked = false;
         }
  }
    else if(parseInt(ThisLimit) === 1){
    document.querySelector('#unlockText')?.classList.add("hidden");
    document.querySelector('#unlockText2')?.classList.remove("hidden");
    document.querySelector('#unlockText3')?.classList.add("hidden");
    document.querySelectorAll('.option-single_bundles')?.forEach((btn) => {btn.classList.remove('disabled_free_items')});
      const freeInput = document.querySelector('.free_product_input_bundles');
         if (freeInput) {
        freeInput.checked = true;
         }
    }
  else{
    document.querySelectorAll('.option-single_bundles')?.forEach((btn) => {btn.classList.remove('disabled_free_items')});
    document.querySelector('#unlockText')?.classList.add("hidden");
    document.querySelector('#unlockText2')?.classList.add("hidden");
    document.querySelector('#unlockText3')?.classList.remove("hidden");
     const freeInput = document.querySelector('.free_product_input_bundles');
         if (freeInput) {
        freeInput.checked = true;
        // freeInput.value = 2;
         }
    
  }
  if (AllfreeProducts && AllfreeProducts.length > 0 && ThisLimit) {
    var limitValue = parseInt(ThisLimit);

    // Calculate total value of all free products
    AllfreeProducts.forEach((p) => {
      Values += parseInt(p.value) || 0; // Default to 0 if value is not a number
    });

    let newValue = 0;

    AllfreeProducts.forEach((freeProduct) => {
      let productValue = parseInt(freeProduct.value) || 0;
      newValue += productValue;

      // Disable buttons if limit is reached
      if (Values === limitValue) {
        ThisParent.querySelectorAll('.icon_add_qty_bundle, .icon_qty_plus').forEach((btn) => {
          btn.setAttribute('disabled', 'true');
          // btn.classList.add('disabled');
        });
        // document.querySelectorAll('.add-to-cart_bundle')?.forEach((btn) => {btn.removeAttribute('disabled')});
        freeProduct.setAttribute('disabled', true);
      } else {
        // Enable buttons if within limit
          freeProduct.closest('.option-single_bundles').querySelector('.icon_qty_plus').removeAttribute('disabled');
        freeProduct.closest('.option-single_bundles').querySelector('.icon_add_qty_bundle').removeAttribute('disabled');
        freeProduct.removeAttribute('disabled');
        // document.querySelectorAll('.add-to-cart_bundle')?.forEach((btn) => {btn.setAttribute('disabled', true)});
      }

      // Hide/show UI elements based on specific conditions
      if (productValue === 0 && Values < limitValue) {
        freeProduct.closest('.option-single_bundles').querySelector('.free-item-qty-wrapper').classList.add('hidden');
        freeProduct.closest('.option-single_bundles').querySelector('.icon_add_qty_bundle').classList.remove('hidden');
      }

      // Adjust quantity if values exceed the limit
      if (Values > limitValue) {
        ThisParent.querySelectorAll('.qty_input').forEach((input) => {
          input.value = 0;
          // btn.classList.add('disabled');
        });
        ThisParent.querySelectorAll('.icon_add_qty_bundle, .icon_qty_plus').forEach((btn) => {
          btn.removeAttribute('disabled');
           freeProduct.closest('.option-single_bundles').querySelector('.free-item-qty-wrapper').classList.add('hidden');
        freeProduct.closest('.option-single_bundles').querySelector('.icon_add_qty_bundle').classList.remove('hidden');
          // btn.classList.add('disabled');
        });
        // document.querySelectorAll('.add-to-cart_bundle')?.forEach((btn) => {btn.setAttribute('disabled', true)});
      }
    });

    // Ensure values do not exceed the limit
    if (Values > limitValue) {
      Values = 0;
    }

    // Update limit text after operations
    // setTimeout(function() {
    //   var LimitText = document.querySelectorAll('.limits_text');
    //   var bundleBtn = document.querySelector('.add-to-cart_bundle');
    //   if (LimitText) {
    //     LimitText.forEach((text) => {
    //       text.innerHTML = (limitValue - Values) + ' Scents to Go';
    //     });
    //   }
    //    if (bundleBtn) {
    //     if ((limitValue - Values) > 0) {
    //       bundleBtn.innerHTML = (limitValue - Values) + ' Bottles to go';
    //      }
    //     else {
    //        bundleBtn.innerHTML = 'Add to cart';
    //     }
          
    //   }
    // }, 200);
  }
}
// =====================================GIFT ITEMS ===============================
function checkGiftItems() {
  let Selected_bundle = document.querySelector('.bundle_input_radio:checked');
  if(!Selected_bundle){
    Selected_bundle = document.querySelector('.bundle_input_block:checked');
  }
  var giftItemLimit = Selected_bundle ? Selected_bundle.getAttribute('data-gift-items') : 1;
  var allGiftItems = document.querySelectorAll('.list_gift_products [gift-item]');
  
  // Convert NodeList to an array and reverse it
  let giftItemsArray = Array.from(allGiftItems).reverse();
  
  let index = 0;
  giftItemsArray.forEach((item) => {
    index++;
    if (index <= parseInt(giftItemLimit)) {
      item.setAttribute('is_selected_gift', true);
    } else {
      item.removeAttribute('is_selected_gift');
    }
  });

   var ThisGiftItem = Selected_bundle ? Selected_bundle.getAttribute('gift-item-to-add') : '';
   var ThisGiftquantity = Selected_bundle ? Selected_bundle.getAttribute('data-gift-items') : 0;
    var GiftItemGlobaly = document.querySelector('[gift-item-id="'+ThisGiftItem+'"]');
    giftItemsArray?.forEach((gift) => {gift.removeAttribute('is-current-item');})
    GiftItemGlobaly?.setAttribute('is-current-item', true);
    GiftItemGlobaly?.setAttribute('item-quantity', ThisGiftquantity)
}

checkGiftItems()


function checkAllValues(This) {
  let ThisParent = This ? This.closest('.product-single__meta') : null;
  if(!ThisParent){ThisParent = document.querySelector('body');}
  var AllfreeProducts = ThisParent ? ThisParent.querySelectorAll('.qty_input') : null;
  var ThisLimit = document.querySelector('.free_products_limit_bundle');
  var Values = 0;

  if (AllfreeProducts && AllfreeProducts.length > 0 && ThisLimit && ThisLimit.value) {
    var limitValue = parseInt(ThisLimit.value);

    // Calculate total value of all free products
    AllfreeProducts.forEach((p) => {
      Values += parseInt(p.value) || 0; // Default to 0 if value is not a number
    });

    let newValue = 0;

    AllfreeProducts.forEach((freeProduct) => {
      let productValue = parseInt(freeProduct.value) || 0;
      newValue += productValue;

      // Disable buttons if limit is reached
      if (Values === limitValue) {
        ThisParent.querySelectorAll('.icon_add_qty_landing, .icon_qty_plus').forEach((btn) => {
          btn.setAttribute('disabled', 'true');
          // btn.classList.add('disabled');
        });
        document.querySelectorAll('.add-to-cart_bundle')?.forEach((btn) => {btn.removeAttribute('disabled')});
        freeProduct.setAttribute('disabled', true);
      } else {
        // Enable buttons if within limit
          freeProduct.closest('.landing_bundle-free-p').querySelector('.icon_qty_plus').removeAttribute('disabled');
        freeProduct.closest('.landing_bundle-free-p').querySelector('.icon_add_qty_landing').removeAttribute('disabled');
        freeProduct.removeAttribute('disabled');
        document.querySelectorAll('.add-to-cart_bundle')?.forEach((btn) => {btn.setAttribute('disabled', true)});
      }

      // Hide/show UI elements based on specific conditions
      if (productValue === 0 && Values < limitValue) {
        freeProduct.closest('.landing_bundle-free-p').querySelector('.landing_bundle_qty_btns').classList.add('hidden');
        freeProduct.closest('.landing_bundle-free-p').querySelector('.icon_add_qty_landing').classList.remove('hidden');
      }

      // Adjust quantity if values exceed the limit
      if (Values > limitValue) {
        ThisParent.querySelectorAll('.qty_input').forEach((input) => {
          input.value = 0;
          // btn.classList.add('disabled');
        });
        ThisParent.querySelectorAll('.icon_add_qty_landing, .icon_qty_plus').forEach((btn) => {
          btn.removeAttribute('disabled');
           freeProduct.closest('.landing_bundle-free-p').querySelector('.landing_bundle_qty_btns').classList.add('hidden');
        freeProduct.closest('.landing_bundle-free-p').querySelector('.icon_add_qty_landing').classList.remove('hidden');
          // btn.classList.add('disabled');
        });
        document.querySelectorAll('.add-to-cart_bundle')?.forEach((btn) => {btn.setAttribute('disabled', true)});
      }
    });

    // Ensure values do not exceed the limit
    if (Values > limitValue) {
      Values = 0;
    }

    // Update limit text after operations
    setTimeout(function() {
      var LimitText = document.querySelectorAll('.limits_text');
      var bundleBtn = document.querySelector('.add-to-cart_bundle');
      if (LimitText) {
        LimitText.forEach((text) => {
          text.innerHTML = (limitValue - Values) + ' Scents to Go';
        });
      }
       if (bundleBtn) {
        if ((limitValue - Values) > 0) {
          bundleBtn.innerHTML = (limitValue - Values) + ' Bottles to go';
         }
        else {
           bundleBtn.innerHTML = 'Add to cart';
        }
          
      }
    }, 200);
  }
}

var roundedPrice = document.querySelectorAll('[price-round]');
roundedPrice.forEach((price) => {
    var ThisPrice = parseFloat(price.getAttribute('data-price')) / 100;
    var symbol = price.getAttribute('data-symbol'); // corrected 'symble' to 'symbol'
    var Price = `${symbol}${Math.round(ThisPrice)}`;
    price.textContent = Price; // Updates the text content of the element
});

